import { finleyAssertUnreachable } from '@finley-technologies/common';
import { Organization } from '@finley-technologies/finley-types';

import { numberWithCommas } from 'packages/common-frontend/utils';

/**
 * Format a financial value based on the localization config
 * @param value - The numeric value to format
 * @param config - The financial statement configuration
 * @returns Formatted string with appropriate suffix and dollar sign
 */
export const formatFinancialValue = (
  value: number | null | undefined,
  config?: Organization.FinancialStatementLocalizationConfig,
): string => {
  if (value === null || value === undefined) {
    return '-';
  }

  // If config is not provided, use full format
  if (!config) {
    return `$${numberWithCommas(value.toFixed(0))}`;
  }

  const absValue = Math.abs(value);
  const isNegative = value < 0;
  const negativePrefix = isNegative ? '-' : '';

  switch (config.financialFormatting.displayFormat) {
    case 'K': {
      const formattedValue = (absValue / 1000).toFixed(1).replace(/\.0$/, '');
      return `${negativePrefix}$${numberWithCommas(formattedValue)}K`;
    }
    case 'M': {
      const formattedValue = (absValue / 1000000)
        .toFixed(1)
        .replace(/\.0$/, '');
      return `${negativePrefix}$${numberWithCommas(formattedValue)}M`;
    }
    case 'B': {
      const formattedValue = (absValue / 1000000000)
        .toFixed(1)
        .replace(/\.0$/, '');
      return `${negativePrefix}$${numberWithCommas(formattedValue)}B`;
    }
    case 'full': {
      return `${negativePrefix}$${numberWithCommas(absValue.toFixed(0))}`;
    }
    default: {
      return finleyAssertUnreachable(config.financialFormatting.displayFormat);
    }
  }
};
